module.exports = __webpack_public_path__ + "img/jetrodder_driving.36f33332.svg";